// extracted by mini-css-extract-plugin
module.exports = {"header":"DefaultLayout_header__czO7y","pageTitle":"DefaultLayout_pageTitle__2Vf0n","content":"DefaultLayout_content__aYkNh"};